import { getSearchParams } from './getSearchParams';

export const getAllParamsFormUrl = () => {
  const { pathname, search } = window.location;
  const splittedPath = pathname.split('/').filter(p => p !== '');
  const searchParams = getSearchParams(search);
  const lastPath = splittedPath[splittedPath.length - 1];
  const siteName = lastPath !== 'auth' ? lastPath : searchParams.siteName;

  return {
    siteName,
    macAddress: searchParams.id,
    ssid: searchParams.ssid,
    apMacAddress: searchParams.ap,
  };
};
